import axios from 'axios'
import router from '../router/router'
import qs from 'qs'
import store from '../store/store'
import { Message } from 'element-ui';


axios.defaults.baseURL = getBaseUrl();

function getBaseUrl() {
    var curWwwPath = window.document.location.href;

    var protocol = window.document.location.protocol;
    var hostname = window.document.location.hostname;
    var host = window.document.location.host;
    var port = window.document.location.port;
    //判断是访问客戶端还是后台
    if (curWwwPath.indexOf("8090") >= 0) {
        curWwwPath = protocol + "//" + hostname + ":9280/v1/admin";
    } else {
        curWwwPath = protocol + "//" + hostname + "/v1/admin";
    }
    // 本地正式服
    // curWwwPath = 'https://w.swlogistics.com.hk/v1/admin'
    // 欧振--
    // curWwwPath = 'http://192.168.50.36:9280/v1/admin'
    return curWwwPath;
}

function getImageUrl() {
    var curWwwPath = window.document.location.href;
    var protocol = window.document.location.protocol;
    var hostname = window.document.location.hostname;
    //判断是访问客戶端还是后台
    if (curWwwPath.indexOf("8090") >= 0) {
        curWwwPath = protocol + "//" + hostname + ":9280/";

    } else {
        curWwwPath = protocol + "//" + hostname + "/";
    }
    return curWwwPath;
}
axios.defaults.timeout = 100000;
/*axios.defaults.headers.post['Content-Type']='application/json;charset=UTF-8';*/
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
/*axios.interceptors.request.use(
 config=>{
 if(store.state.staff){
 config.headers["Authorization"] = store.state.staff.token;
 }
 /!*if (config.method === 'post'||config.method==='patch') {
 config.data = qs.stringify(config.data);
 }*!/
 return config;
 },
 error=>{
 console.log("err request");
 return Promise.reject(error);
 }
 );
 var  isOutLogin=0;
 axios.interceptors.response.use(
 response => {
 return response.data;
 },
 error => {
 if (error.response) {
 switch (error.response.status) {
 case 401:
 isOutLogin++;
 if (isOutLogin==1){
 Message.warning("登录超时!");
 }
 window.sessionStorage.clear();
 router.options.routes.splice(2,router.options.routes.length-2);
 router.push({path: '/login'});
 break;
 case 504:
 window.sessionStorage.clear();
 router.options.routes.splice(2,router.options.routes.length-2);
 router.push({path: '/login'});
 break;
 case  200:
 isOutLogin=0;
 break;

 }
 }
 if (error.toString().indexOf('timeout')>=0){
 Message.warning("請求超时！");
 }
 return Promise.reject(error);
 }
 );*/
// axios 配置
// http request 拦截器
axios.interceptors.request.use(
    config => {
        //console.log(store.state.staff.token)
        let token = store.state.staff.token;
        if (token && config.url != config.baseUrl) {
            config.headers["Authorization"] = token;
        }

        return config;
    },
    err => {
        return Promise.reject(err);
    });

// http response 拦截器
axios.interceptors.response.use(
    res => {
        //console.log(res);
        if (res.data.errcode === 401) {
            // 401 清除token信息并跳转到登录页面
            sessionStorage.clear();
            router.replace({
                path: '/login'
            })
        }
        return res;
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    // 401 清除token信息并跳转到登录页面
                    sessionStorage.clear();
                    router.replace({
                        path: '/login'
                    })
            }
        }
        return Promise.reject(error)
    });


//=======================Token=========================
export const getToken = params => { return axios.get("/token", { params: params }) };
export const getLogout = id => { return axios.get("/logout/" + id) };
export const imageUrl = url => { return getImageUrl() + "upload/" + url; };


//=======================Permission=========================
export const getPermissionTree = params => { return axios.get("/permission-tree", { params: params }) };

export const getMenuTree = params => { return axios.get("/menu-tree", { params: params }) };

//=======================Role=========================
export const getRoleAll = params => { return axios.get("/roles", { params: params }) };

export const getRoleList = params => { return axios.get("/role", { params: params }) };

export const getRoleById = id => { return axios.get("/role/" + id) };

export const insertRole = data => { return axios.post("/role", data) };

export const updateRole = data => { return axios.post("/updateRole", data) };

export const deleteRole = id => { return axios.delete("/role/" + id) };

export const getAllRoleList = params => { return axios.get("/roleList", { params: params }) };
export const addRoleByCopy = id => { return axios.get("/addRoleByCopy/" + id) };

export const getStffRoles = roleId => { return axios.get("/staffRole/" + roleId) };
//=======================Staff=========================
export const getStaffList = params => { return axios.get("/staff", { params: params }) };

export const getStaffById = id => { return axios.get("/staff/" + id) };

export const getStaffByLoginName = loginName => { return axios.get("/getStaffByLoginName/" + loginName) };

export const insertStaff = data => { return axios.post("/staff", data) };

export const updateStaff = data => { return axios.patch("/staff", data) };

export const deleteStaff = id => { return axios.delete("/staff/" + id) };

export const getStaffAllList = () => { return axios.get("/staff/all") };

export const getStaffAll = () => { return axios.get("/staff/listAll") };

export const getSalesList = data => { return axios.get("/staff/salesList") };

export const getStaffByTypeList = params => { return axios.get("/staff/staffType", { params: params }) };

export const modifyStaffPassword = password => { return axios.post("/staff/modifyStaffPassword/" + password) };

export const modifyStaffByIdPassword = params => { return axios.post("/staff/modifyStaffByIdPassword", params) };

export const getValidateStaffStor = data => { return axios.get("/staff/stor/" + data.storId + "/" + data.staffId) };

//=======================Node=========================
export const getNodeAll = params => { return axios.get("/nodes", { params: params }) };

export const getNodeList = params => { return axios.get("/node", { params: params }) };

export const getNodeById = id => { return axios.get("/node/" + id) };

export const insertNode = data => { return axios.post("/node", data) };

export const updateNode = data => { return axios.patch("/node", data) };

export const deleteNode = id => { return axios.delete("/node/" + id) };



//=======================IP=========================
export const getIpList = params => { return axios.get("/ip", { params: params }) };

export const getIpById = id => { return axios.get("/ip/" + id) };

export const insertIp = data => { return axios.post("/ip", data) };

export const updateIp = data => { return axios.patch("/ip", data) };

export const deleteIp = id => { return axios.delete("/ip/" + id) };


//=======================User=========================
export const getUserList = params => { return axios.get("/user", { params: params }) };

export const getUserById = id => { return axios.get("/user/" + id) };

export const insertUser = data => { return axios.post("/user", data) };

export const updateUser = data => { return axios.patch("/user", data) };

export const updateUserStatus = data => { return axios.patch("/user-status", data) };

export const updateUserExpiry = data => { return axios.patch("/user-expiry", data) };

//=======================Customer=========================
export const getCustomerList = params => { return axios.get("/customer", { params: params }) };

export const getSearchList = params => { return axios.get("/customerSearch", { params: params }) };

export const getCustomerCodeList = params => { return axios.get("/customerCode",) };

export const getValidateCustomerCode = params => { return axios.get("/customer/validateCustomerCode", { params: params }) };

export const getCustomerById = id => { return axios.get("/customer/" + id) };

export const insertCustomer = data => { return axios.post("/insertCustomer", data) };

export const updateCustomer = data => { return axios.patch("/customer", data) };

export const validateCustomerById = id => { return axios.get("/validateCustomer/" + id) };
export const deleteCustomerById = id => { return axios.delete("/deleteCustomer/" + id) };
//=======================Location=========================
export const getLocationBycusId = cusId => { return axios.get("/location/cusId/" + cusId) };
export const getLocationList = params => { return axios.get("/location", { params: params }) };

export const getLocationById = id => { return axios.get("/location/" + id) };

export const insertLocation = data => { return axios.post("/location", data) };

export const updateLocation = data => { return axios.patch("/location", data) };

export const deleteLocationById = id => { return axios.delete("/location/" + id) };
export const getValidateLocationName = params => { return axios.get("/customer/validateLocationName", { params: params }) };
export const getLocationByXY = params => { return axios.get("/location/locationByXY", { params: params }) };


//=======================StorIn=========================
export const getStorInList = params => { return axios.get("/storIn", { params: params }) };
export const getStorInListTwo = params => { return axios.get("/storInTwo", { params: params }) };
export const insertStorIn = params => { return axios.post("/addStorIn", params) };
export const updateStorIn = params => { return axios.post("/updateStorIn", params) };
export const selStorInItem = params => { return axios.get("/selStorInItem", { params: params }) };
export const getStorInListId = id => { return axios.get("/getStorInListId/" + id) };
export const selStorInItemCustomerId = params => { return axios.get("/selStorInItemCustomerId/", { params: params }) };
export const getStorInItemListByCusId = id => { return axios.get("/selStorInItemByCusId/" + id) };
export const getStorInCodeList = params => { return axios.get("/getStorInCodeList") };
export const delStorInDate = id => { return axios.get("/delStorInDate/" + id) };
export const delStorInItem = id => { return axios.get("/delStorInItem/" + id) };
export const getCusInventory = id => { return axios.get("/cusInventory/" + id) };
export const getCIdList = params => { return axios.get("/getCIdList/", { params: params }) };
export const getPrePrice = params => { return axios.get("/selNewPrice", { params: params }) };
export const getStotInOutRecord = id => { return axios.get("/getRecordList/" + id) };
export const selCode = code => { return axios.get("/selCodeList/" + code) };
//=======================Location=========================
export const getLocationByState = state => { return axios.get("/location/state/" + state) };
export const updateLocationWhether = params => { return axios.get("/updateLocationWhether", { params: params }) };


//=======================StorOn=========================
export const getStorOnList = params => { return axios.get("/storOn", { params: params }) };
export const getStorOnListTwo = params => { return axios.get("/storOnTwo", { params: params }) };
export const insertStorOn = params => { return axios.post("/addStorOn", params) };
export const getStorOnItemStorinIdBy = id => { return axios.get("/getStorOnItemStorinIdBy/" + id) };
export const getStorOnListId = id => { return axios.get("/getStorOnListId/" + id) };
export const getStorOnCodeList = params => { return axios.get("/getStorOnCodeList") };
export const getPrintingListByStorDateId = id => { return axios.get("/getPrintingListByStorDateId/" + id) };
export const getPrintingList = params => { return axios.get("/getPrintingList/", { params: params }) };
export const getStorOnOkList = params => { return axios.post("/getStorOnList", params) };
//=======================Remark=========================
export const getRemarkList = params => { return axios.get("/remarkList", { params: params }) };

export const getAllRemarkList = typeId => { return axios.get("/getAllRemarkList/" + typeId) };

export const getRemarkById = id => { return axios.get("/remark/" + id) };

export const insertRemark = data => { return axios.post("/remark", data) };

export const updateRemark = data => { return axios.patch("/remark", data) };

export const deleteRemarkById = id => { return axios.delete("/remark/" + id) };
export const getAllTypeList = params => { return axios.get("/getAllTypeList", { params: params }) };

//=======================Group=========================
export const getGroupByCatCode = catCode => { return axios.get("/groupByCatCode/" + catCode) };

export const getCustGroupMgtList = params => { return axios.get("/CustGroupList", { params: params }) };
export const insertCustGroup = data => { return axios.post("/custGroups", data) };
export const updateCustGroup = data => { return axios.post("/custGroupUpdate", data) };
export const getCustGroupMgtById = id => { return axios.get("/groupMgtId/" + id) };

export const getCustGroupMgtDetailsList = params => { return axios.get("/custGroupDetailList", { params: params }) };
export const queryAllCustByCode = custNo => { return axios.get("/custGroup/all/" + custNo) };
export const updateCustNoGroupId = data => { return axios.post("/cust/groupId", data) };

export const updateCustGroupIds = data => { return axios.post("/custNo/groupId", data) };
export const deleteGroupName = data => { return axios.post("/cust/deleteGroupId", data) };
export const getCustAllCustMgtList = params => { return axios.get("/cust/all/custMgt", { params: params }) };



//==================task====================
export const getTaskList = params => { return axios.get("/taskList", { params: params }) };
export const insertTask = data => { return axios.post("/insertTask", data) };
export const updateTask = data => { return axios.patch("/updateTask", data) };

export const getTaskById = id => { return axios.get("/taskRecord/" + id) };
export const deleteTaskById = id => { return axios.delete("/delete/" + id) };




export const getCustFileList = params => { return axios.get("/uploadFile", { params: params }) };
export const deleteCustFile = id => { return axios.delete("/fileUpload/" + id) };


export const getCalendarTaskList = params => { return axios.get("/calendarList", { params: params }) };
//=======================feedBack=========================
export const getFeedBackList = params => { return axios.get("/feedList", { params: params }) };
export const insertFeedBack = data => { return axios.post("/insertFeedBack", data) };
export const getFeedById = id => { return axios.get("/feedRecord/" + id) };
export const updateFeedDate = data => { return axios.post("/updateFeed", data) };

export const updateFeedSave = data => { return axios.post("/updateFeedSave", data) };
//=======================rolling=========================
export const getRollingsList = params => { return axios.get("/rollList", { params: params }) };
export const insertRolling = data => { return axios.post("/insertRolling", data) };
export const getRollingsById = id => { return axios.get("/rollRecord/" + id) };
export const updateRolling = data => { return axios.post("/updateRolling", data) };
export const getRollingItemRecordById = params => { return axios.get("/rollItemRecord", { params: params }) };
export const getRollingItemRecordByNo = params => { return axios.get("/getRollItem", { params: params }) };

export const getRollingListById = id => { return axios.get("/rollRecordList/" + id) };

export const updateRollSave = data => { return axios.post("/updateRollSave", data) };
export const deleteRollingById = id => { return axios.delete("/deleteRoll/" + id) };
//=======================item=========================
export const itemRecord = params => { return axios.get("/itemRecord", { params: params }) };
export const getItemAll = itemCode => { return axios.get("/item/all/" + itemCode) };
export const getItemStorList = params => { return axios.get("/itemStorList", { params: params }) };
export const getItemAllList = () => { return axios.get("/item/allItem") };

export const getItemStorListAll = params => { return axios.get("/itemStorListAll", { params: params }) };
export const deleteItemById = id => { return axios.delete("/deleteItem/" + id) };
export const getItemRecord = params => { return axios.get("/getItem", { params: params }) };
export const updateItemStock = data => { return axios.post("/updateItem", data) };
export const addItems = data => { return axios.post("/addItems", data) };
//=======================stockAdj=========================
export const getStockList = params => { return axios.get("/stockList", { params: params }) };
export const insertStockAdj = data => { return axios.post("/insertStockAdj", data) };
export const getStockAdjId = id => { return axios.get("/stockRecord/" + id) };
export const updateStockAdj = data => { return axios.post("/updateStockAdj", data) };
export const getValidateAdjustmentItemCode = data => { return axios.get("/stockAdjustment/" + data.id + "/" + data.itemId) };
export const addStockAdjustmentList = data => { return axios.post("/stockAdjustment/addList", data) };

export const deleteStockAdjustment = id => { return axios.delete("/stockAdjustment/" + id) };
export const getStockAdjustmentImport = params => { return axios.get("/stockAdjustment/import", { params: params }) };


export const getTaskCalendarList = () => { return axios.get("/taskCalendarList") };
export const insertTaskCalendar = data => { return axios.post("/insertTaskCalendar", data) };
export const updateTaskCalendar = data => { return axios.patch("/updateTaskCalendar", data) };
export const getTaskCalendarById = id => { return axios.get("/taskCalendarRecord/" + id) };
export const deleteTaskCalendarById = id => { return axios.delete("/deleteCalendar/" + id) };



//=======================feedBack=========================
export const getJobOrderList = params => { return axios.get("/jobOrderList", { params: params }) };
export const insertJobOrder = data => { return axios.post("/insertJobOrder", data) };
export const getJobRecord = id => { return axios.get("/jobRecord/" + id) };
export const updateJobOrder = data => { return axios.post("/updateJobOrder", data) };
export const getJobNo = params => { return axios.get("/jobNoRecord", { params: params }) };

export const getJobJsonList = params => { return axios.get("/jobPrintList", { params: params }) };
export const getJobPalletList = params => { return axios.get("/jobPallentPrint", { params: params }) };
export const updateJobPallet = data => { return axios.post("/updatePallet", data) };

export const updateJobPalletPrint = data => { return axios.post("/updatePrint", data) };


// WEBPACK FOOTER //
// ./src/api/api.js